import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-volume",
  "use": "icon-s-volume-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-volume\"><path d=\"M12 18.865a1 1 0 0 1-1.64.768L6 16H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5l4.36-3.633a1 1 0 0 1 1.64.768zM10 5.27 6.724 8H2v6h4.724L10 16.73zm8.778-2.048A10.97 10.97 0 0 1 22 11c0 3.038-1.231 5.788-3.222 7.778l-1.414-1.414A8.97 8.97 0 0 0 20 11a8.97 8.97 0 0 0-2.636-6.364zM15.95 6.05A6.98 6.98 0 0 1 18 11a6.98 6.98 0 0 1-2.05 4.95l-1.414-1.414A4.98 4.98 0 0 0 16 11c0-1.38-.56-2.63-1.464-3.536z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol